module.exports = __webpack_public_path__ + "img/Mixed-fruits-800x527.e105da8d.jpg";